"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Token = void 0;
class Token {
  static isTokenRowDelimiter(token) {
    const content = token.token;
    return content === '\r' || content === '\n' || content === '\r\n';
  }
  static isTokenCarriageReturn(token, parserOptions) {
    return token.token === parserOptions.carriageReturn;
  }
  static isTokenComment(token, parserOptions) {
    return parserOptions.supportsComments && !!token && token.token === parserOptions.comment;
  }
  static isTokenEscapeCharacter(token, parserOptions) {
    return token.token === parserOptions.escapeChar;
  }
  static isTokenQuote(token, parserOptions) {
    return token.token === parserOptions.quote;
  }
  static isTokenDelimiter(token, parserOptions) {
    return token.token === parserOptions.delimiter;
  }
  token;
  startCursor;
  endCursor;
  constructor(tokenArgs) {
    this.token = tokenArgs.token;
    this.startCursor = tokenArgs.startCursor;
    this.endCursor = tokenArgs.endCursor;
  }
}
exports.Token = Token;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJUb2tlbiIsImlzVG9rZW5Sb3dEZWxpbWl0ZXIiLCJ0b2tlbiIsImNvbnRlbnQiLCJpc1Rva2VuQ2FycmlhZ2VSZXR1cm4iLCJwYXJzZXJPcHRpb25zIiwiY2FycmlhZ2VSZXR1cm4iLCJpc1Rva2VuQ29tbWVudCIsInN1cHBvcnRzQ29tbWVudHMiLCJjb21tZW50IiwiaXNUb2tlbkVzY2FwZUNoYXJhY3RlciIsImVzY2FwZUNoYXIiLCJpc1Rva2VuUXVvdGUiLCJxdW90ZSIsImlzVG9rZW5EZWxpbWl0ZXIiLCJkZWxpbWl0ZXIiLCJzdGFydEN1cnNvciIsImVuZEN1cnNvciIsImNvbnN0cnVjdG9yIiwidG9rZW5BcmdzIiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wYXJzZXIvVG9rZW4udHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXSwibWFwcGluZ3MiOiI7Ozs7OztBQVVBLE1BQWFBLEtBQUs7RUFDUCxPQUFPQyxtQkFBbUJBLENBQUNDLEtBQVk7SUFDMUMsTUFBTUMsT0FBTyxHQUFHRCxLQUFLLENBQUNBLEtBQUs7SUFDM0IsT0FBT0MsT0FBTyxLQUFLLElBQUksSUFBSUEsT0FBTyxLQUFLLElBQUksSUFBSUEsT0FBTyxLQUFLLE1BQU07RUFDckU7RUFFTyxPQUFPQyxxQkFBcUJBLENBQUNGLEtBQVksRUFBRUcsYUFBNEI7SUFDMUUsT0FBT0gsS0FBSyxDQUFDQSxLQUFLLEtBQUtHLGFBQWEsQ0FBQ0MsY0FBYztFQUN2RDtFQUVPLE9BQU9DLGNBQWNBLENBQUNMLEtBQVksRUFBRUcsYUFBNEI7SUFDbkUsT0FBT0EsYUFBYSxDQUFDRyxnQkFBZ0IsSUFBSSxDQUFDLENBQUNOLEtBQUssSUFBSUEsS0FBSyxDQUFDQSxLQUFLLEtBQUtHLGFBQWEsQ0FBQ0ksT0FBTztFQUM3RjtFQUVPLE9BQU9DLHNCQUFzQkEsQ0FBQ1IsS0FBWSxFQUFFRyxhQUE0QjtJQUMzRSxPQUFPSCxLQUFLLENBQUNBLEtBQUssS0FBS0csYUFBYSxDQUFDTSxVQUFVO0VBQ25EO0VBRU8sT0FBT0MsWUFBWUEsQ0FBQ1YsS0FBWSxFQUFFRyxhQUE0QjtJQUNqRSxPQUFPSCxLQUFLLENBQUNBLEtBQUssS0FBS0csYUFBYSxDQUFDUSxLQUFLO0VBQzlDO0VBRU8sT0FBT0MsZ0JBQWdCQSxDQUFDWixLQUFZLEVBQUVHLGFBQTRCO0lBQ3JFLE9BQU9ILEtBQUssQ0FBQ0EsS0FBSyxLQUFLRyxhQUFhLENBQUNVLFNBQVM7RUFDbEQ7RUFFZ0JiLEtBQUs7RUFFTGMsV0FBVztFQUVYQyxTQUFTO0VBRXpCQyxZQUFtQkMsU0FBb0I7SUFDbkMsSUFBSSxDQUFDakIsS0FBSyxHQUFHaUIsU0FBUyxDQUFDakIsS0FBSztJQUM1QixJQUFJLENBQUNjLFdBQVcsR0FBR0csU0FBUyxDQUFDSCxXQUFXO0lBQ3hDLElBQUksQ0FBQ0MsU0FBUyxHQUFHRSxTQUFTLENBQUNGLFNBQVM7RUFDeEM7O0FBcENKRyxPQUFBLENBQUFwQixLQUFBLEdBQUFBLEtBQUEiLCJpZ25vcmVMaXN0IjpbXX0=